import { ApiService } from './api.service';

export const ApiInjectables: Array<any> = [
  {
    provide: ApiService,
    useClass: ApiService,
  },
];
